import { DateTime } from 'luxon'

import { DATE_WITH_WEEKDAY_FORMAT, TIME_WITH_TIMEZONE_SHORT_FORMAT } from '@/constants/date'

import Tippy from '@/components/UI/Tippy'

export default function SessionDateTooltip({
  children,
  sessionStartDateTime,
  sessionEndDateTime,
}: {
  children: React.ReactElement
  sessionStartDateTime: DateTime
  sessionEndDateTime: DateTime
}): JSX.Element {
  const isSameDate = sessionStartDateTime.toISODate() === sessionEndDateTime.toISODate()
  const sessionStartDateString = sessionStartDateTime.toLocaleString(DATE_WITH_WEEKDAY_FORMAT)
  const sessionEndDateString = sessionEndDateTime.toLocaleString(DATE_WITH_WEEKDAY_FORMAT)
  const sessionStartTimeString = sessionStartDateTime.toLocaleString(DateTime.TIME_SIMPLE)
  const sessionEndTimeString = sessionEndDateTime.toLocaleString(TIME_WITH_TIMEZONE_SHORT_FORMAT)

  return (
    <Tippy
      content={
        <div style={{ textAlign: 'center' }}>
          {isSameDate ? (
            <>
              {sessionStartDateString}
              <br />
              {`${sessionStartTimeString} - ${sessionEndTimeString}`}
            </>
          ) : (
            <>
              {sessionStartDateString}, {`${sessionStartTimeString} -`}
              <br />
              {sessionEndDateString}, {sessionEndTimeString}
            </>
          )}
        </div>
      }
    >
      {children}
    </Tippy>
  )
}
